import SoftBox from "src/components/SoftBox";
import { IQuickbookItem } from "src/interfaces/quickbook.interface";
import { LineItem } from "src/interfaces";
import SoftAutocomplete from "src/components/SoftAutocomplete";

interface QbkItemProps {
  quickbooksItems: IQuickbookItem[];
  lineItem?: LineItem;
  disabled?: boolean;
  onLineItemEditted: (lineItem: Partial<LineItem>) => void;
}

export const QbkItem = ({
  quickbooksItems,
  lineItem,
  disabled,
  onLineItemEditted,
}: QbkItemProps) => {
  return (
    <SoftBox width={220} sx={{ background: "white" }}>
      <SoftAutocomplete
        options={quickbooksItems
          .filter((item) => item.Active)
          .map((item) => ({
            label: item.FullyQualifiedName,
            value: item.Id,
            parent: {
              name: item.ParentRef?.name,
              value: item.ParentRef?.value,
            },
          }))}
        // groupBy={(option) => option.parent?.name}
        getOptionLabel={(option: any) => option.label}
        sx={{ width: 300 }}
        onChange={(e: any, newValue: any) => {
          console.log("onChange", newValue);
          onLineItemEditted({
            ...(lineItem ? lineItem : {}),
            qboItem: {
              ...newValue,
            },
          });
        }}
        value={
          lineItem?.qboItem?.label
            ? {
                label: lineItem?.qboItem?.label,
                value: lineItem?.qboItem?.value,
                parent: {
                  name: lineItem?.qboItem?.parent?.name,
                  value: lineItem?.qboItem?.parent?.value,
                },
              }
            : null
        }
        isDisabled={disabled}
        placeholder="Select Item"
      />
    </SoftBox>
  );
};
